const webserviceParams = (restPath, payload) => {
    return {
        dispatcher: {},
        restPath: restPath, 
        payload: payload, 
        callbackSuccess: () => {}, 
        callbackError: () => {},
        uid:null,
        process:'',
        decription:'',
    }
}
export default webserviceParams;